export default "__VITE_ASSET__CVKldOwS__"